import * as React from "react";
import { Spacing } from "@stenajs-webui/core";
import { ErrorScreen, LoadingPanel } from "@stenajs-webui/panels";
import { ExistingAgreementListBox } from "../features/existing-agreement/components/ExistingAgreementListBox";
import { ApolloError } from "@apollo/client";
import { RouteAgreement } from "@/features/product-and-price/customers/customer-details/types";
import { MultiLegAgreement } from "../types";

interface Props {
  customerId: string;
  headAgreementId: string;
  year: number;
  routeAgreements: RouteAgreement[];
  multiLegAgreements: MultiLegAgreement[];
  loading: boolean;
  error?: ApolloError;
}

export const RouteAgreementList: React.FC<Props> = React.memo(
  ({
    customerId,
    headAgreementId,
    year,
    routeAgreements,
    multiLegAgreements,
    loading,
    error,
  }) => {
    const filteredRouteAgreementsWithoutMultiLegId = routeAgreements.filter(
      (ra) => !ra.multiLegAgrRouteId
    );

    const showSpinner = loading;

    if (showSpinner) {
      return (
        <Spacing num={6}>
          <LoadingPanel />
        </Spacing>
      );
    }

    if (error) {
      return (
        <Spacing num={6}>
          <ErrorScreen text={error.message} />
        </Spacing>
      );
    }

    return (
      <ExistingAgreementListBox
        customerId={customerId}
        routeAgreements={filteredRouteAgreementsWithoutMultiLegId}
        multiLegAgreements={multiLegAgreements}
        headAgreementId={headAgreementId}
        year={year}
      />
    );
  }
);
